import React from 'react';
import { Link } from 'react-router-dom'; // Step 1: Import Link
import './App.css';

const data = [
  {
    image: "./images/kandy.webp",
    title: "Kandy",
    description: "Kandy is a cultural gem nestled in the heart of Sri Lanka’s central hills. Known for the sacred Temple of the Tooth Relic and the annual Esala Perahera festival, ",
    link: "/kandy"
  },
  {
      image: "./images/sigiriya.png",
      title: "Dambulle",
      description: "Step into history at Dambulla, home to sacred cave temples, ancient art, and spiritual legends of Sri Lanka. ",
      link: "/dabulle"
    },
  {
    image: "./images/anu.webp",
    title: "Anuradhapura",
    description: "Discover the ancient wonders of Anuradhapura, where sacred relics, colossal stupas, and timeless ruins tell the story of Sri Lanka’s golden Buddhist era.",
    link: "/anuradhapura"
  },
  {
    image: "./images/polon.webp",
    title: "Polonnaruwa",
    description: "Walk through the medieval capital of Polonnaruwa, where stone-carved Buddhas, royal palaces, and serene reservoirs reflect the glory of Sri Lanka’s ancient kingdom.",
    link: "/polonnaruwa"
  },
  {
    image: "./images/yala.webp",
    title: "Yala National Park",
    description: "Discover the wilderness, spot wildlife, and experience the thrill of a true safari.",
    link: "/yala"
  },
  {
    image: "./images/galle.webp",
    title: "Galle",
    description: "A blend of colonial history, coastal charm, and marine life",
    link: "/galle"
  },
  {
    image: "./images/jaffna.webp",
    title: "Jaffna",
    description: "A blend of rich history, Tamil culture, and coastal serenity.",
    link: "/jaffna"
  },
  {
    image: "./images/nuweraeliya.webp",
    title: "Nuwara Eliya",
    description: "Cool climate, colonial charm, and stunning landscapes.",
    link: "/nuweraelliya"
  },
  {
    image: "./images/nature.png",
    title: "Ella",
    description: "Nature, adventure, and vibrant night life.",
    link: "/ella"
  },
  {
    image: "./images/colombo.webp",
    title: "Colombo",
    description: "Luxury, culture, and city vibes in one place.",
    link: "/colombo"
  }

];

const InfoSection = () => {
  return (
    <div className="sri-info-section">
      {/* Heading */}
      <h2 className="sri-section-main-heading">Destinations in Sri Lanka</h2>

      {/* Grid of destination boxes */}
      <div className="sri-box-row2">
        {data.map((item, index) => (
          <div className="sri-info-box2" key={index}>
            <img src={item.image} className="sri-info-image" />
            <div className="sri-info-content">
              <h3 className="sri-info-title">{item.title}</h3>
              <p className="sri-info-description">{item.description}</p>
              <Link to={item.link} className="read-more-button">Read More ...</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoSection;
